const dateTime = new Intl.DateTimeFormat(undefined, {
  weekday: 'short',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
});

const dateOnly = new Intl.DateTimeFormat(undefined, {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
});

/** The API sends UTC without a trailing Z in some serialiser configurations. */
function toDate(value) {
  if (!value) return null;
  const normalised = /[Zz]|[+-]\d{2}:\d{2}$/.test(value) ? value : `${value}Z`;
  const parsed = new Date(normalised);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatKickoff(value) {
  const date = toDate(value);
  return date ? dateTime.format(date) : '--';
}

export function formatDate(value) {
  const date = toDate(value);
  return date ? dateOnly.format(date) : '--';
}

export function isPast(value) {
  const date = toDate(value);
  return date ? date.getTime() <= Date.now() : false;
}

export { toDate };
